import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-paycircle',
  name: 'Access PayCircle',
  category: 'access-integrations',
  description: 'PayCircle payroll integration for bureau-level payroll management',
  icon: 'Banknote',
  color: 'emerald',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'paycircle',
      required: true,
    },
  ],
  tags: ['access', 'paycircle', 'payroll', 'hr', 'payments', 'salary'],
};

export default definition;
